import React from 'react';
import { MapPin, Compass, Umbrella, Activity, ChevronLeft, ChevronRight } from 'lucide-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { useSiteImages } from '@/hooks/useSiteImages';

const RegionSection = () => {
  const { images } = useSiteImages('region');
  const regionImages = images.map((img) => ({ src: img.url, alt: img.alt }));

  return <div className="max-w-5xl mx-auto">
      <h2 className="text-3xl font-semibold mb-8 text-center">La Région</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="rounded-lg overflow-hidden shadow-md relative group">
          <Swiper spaceBetween={0} slidesPerView={1} pagination={{
          clickable: true
        }} navigation={{
          prevEl: '.swiper-button-prev-region',
          nextEl: '.swiper-button-next-region'
        }} modules={[Pagination, Navigation]} className="w-full h-80">
          {regionImages.map((img, index) => (
            <SwiperSlide key={index}>
              <img
                src={img.src}
                alt={img.alt || `Paysage breton - vue ${index + 1}`}
                className="w-full h-80 object-cover" 
                loading="lazy"
                decoding="async"
                onError={e => {
                  e.currentTarget.src = 'https://placehold.co/600x400?text=Région';
                }} 
              />
            </SwiperSlide>
          ))}
          </Swiper>
          
          {/* Navigation Arrows */}
          <button className="swiper-button-prev-region hidden group-hover:flex absolute top-1/2 -translate-y-1/2 left-4 z-10 p-2 bg-white bg-opacity-70 hover:bg-opacity-100 rounded-full shadow transition-all duration-200 items-center justify-center" aria-label="Image précédente">
            <ChevronLeft className="h-5 w-5" />
          </button>
          
          <button className="swiper-button-next-region hidden group-hover:flex absolute top-1/2 -translate-y-1/2 right-4 z-10 p-2 bg-white bg-opacity-70 hover:bg-opacity-100 rounded-full shadow transition-all duration-200 items-center justify-center" aria-label="Image suivante">
            <ChevronRight className="h-5 w-5" />
          </button>
        </div>
        
        <div>
          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="bg-blue-100 p-3 rounded-full">
                <MapPin className="h-5 w-5 text-blue-500" />
              </div>
              <div>
                <h3 className="font-medium text-lg">Plages à proximité</h3>
                <p className="text-gray-600">Profitez de plages de sable fin à moins de 5 minutes à pied</p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="bg-blue-100 p-3 rounded-full">
                <Umbrella className="h-5 w-5 text-blue-500" />
              </div>
              <div>
                <h3 className="font-medium text-lg">Sentier côtier</h3>
                <p className="text-gray-600">À 5 minutes à pied pour des randonnées inoubliables</p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="bg-blue-100 p-3 rounded-full">
                <Compass className="h-5 w-5 text-blue-500" />
              </div>
              <div>
                <h3 className="font-medium text-lg">Commerces</h3>
                <p className="text-gray-600">Tous commerces à moins de 5 minutes en voiture</p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="bg-blue-100 p-3 rounded-full">
                <Activity className="h-5 w-5 text-blue-500" />
              </div>
              <div>
                <h3 className="font-medium text-lg">Activités</h3>
                <p className="text-gray-600">Sports nautiques, pêche, tennis, golf à proximité</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default RegionSection;